// extracted by mini-css-extract-plugin
export default {"selectContainer":"CurrencySelector_selectContainer__kBauR","selectTitle":"CurrencySelector_selectTitle__QTclt","disabled":"CurrencySelector_disabled__XPYAj"};